import React from 'react'
import CatholicHouseholdMemberQuery from "./CatholicHouseholdMemberQuery";


export const CatholicHouseholdMemberQueryHolyOrders = ({
                                                           ...props
                                                       }) => <CatholicHouseholdMemberQuery
    sacrament_type={"holy_orders"} {...props} />


